module.exports = __webpack_public_path__ + "static/media/QR-baby-mobile.02ee591f.png";